module.exports = __webpack_public_path__ + "static/media/teeth.85eed02c.svg";